import { render } from "./Four.vue?vue&type=template&id=278a7c2b"
import script from "./Four.vue?vue&type=script&lang=js"
export * from "./Four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__